// Cross-tab, reload-proof idle clock.
//
// The last-activity time lives in localStorage (shared across every tab of this
// origin) rather than in an in-memory timer. Idle detection is always *computed*
// from this timestamp — never left to a setTimeout to fire on schedule — so a
// backgrounded/suspended tab, a reload, or a freshly-opened tab can only ever
// make us re-check the deadline, never silently miss or reset it.

const STORAGE_KEY = "gardio:idle:lastActivityAt";

export const IDLE_STORAGE_KEY = STORAGE_KEY;

export function readIdleClock(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const val = raw ? parseInt(raw, 10) : NaN;
    return Number.isFinite(val) ? val : 0;
  } catch {
    return 0;
  }
}

export function touchIdleClock(): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // Storage disabled/full (e.g. Safari private mode) — idle detection
    // degrades to in-tab-only, which is still better than nothing.
  }
}

export function clearIdleClock(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}
